<template>
  <div class="user">
    <div class="common-level-rail">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-plus" @click="addClick">
            添加商品
          </el-button>
        </el-form-item>
        <el-form-item label="商品名称">
          <el-input size="small" v-model="searchForm.productName" placeholder="请输入商品名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="product.productName" label="产品" style="min-width: 400px">
            <template slot-scope="scope">
              <div class="product-info">
                <div class="pic"><img v-img-url="scope.row.product.imagePath" alt=""/></div>
                <div class="info">
                  <div class="name">{{ scope.row.product.productName }}</div>
                  <div class="price">￥{{ scope.row.product.productPrice }}</div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="product.salesActual" label="实际销量" width="180"></el-table-column>
          <el-table-column prop="product.productStock" label="库存数" width="180"></el-table-column>
          <el-table-column prop="product.viewTimes" label="点击数" width="180"></el-table-column>
          <el-table-column prop="product.createTime" label="添加时间" width="180"></el-table-column>
          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <div class="table-btn-column">
                <el-button @click="delClick(scope.row)" type="text" size="small">删除商品
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    <getproduct :isProduct="open_product" :islist="true" :dataType="1" :groupId="groupId"
                @closeDialog="closeDialogFunc($event, 'add')"/>
  </div>
</template>

<script>
import PorductApi from '@/api/product.js'
import getproduct from '@/components/product/GroupProduct.vue'

export default {
  name: 'plist',
  components: {getproduct},
  data () {
    return {
      groupId: 0,
      /*是否正在加载*/
      loading: true,
      /*一页多少条*/
      pageSize: 15,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索参数*/
      searchForm: {
        productName: ''
      },
      /*列表数据*/
      tableData: [],
      open_product: false,
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.groupId = parseInt(this.$route.query.groupId || 0)
      this.getData()
    },
    /*选择第几页*/
    handleCurrentChange (val) {
      let self = this
      self.loading = true
      self.curPage = val
      self.getData()
    },

    /*每页多少条*/
    handleSizeChange (val) {
      this.pageSize = val
      this.getData()
    },
    /*搜索查询*/
    onSubmit () {
      this.curPage = 1
      this.getData()
    },
    /*获取列表*/
    getData () {
      let self = this
      let Params = self.searchForm
      Params.pageIndex = self.curPage
      Params.pageSize = self.pageSize
      Params.groupId = self.groupId
      self.loading = true
      PorductApi.getGroupProductList(Params, true)
        .then(res => {
          self.loading = false
          self.tableData = res.data.records
          self.totalDataNumber = res.data.total
        })
        .catch(error => {
          self.loading = false
        })
    },
    /*打开添加*/
    addClick () {
      this.open_product = true
    },
    closeDialogFunc (e) {
      let self = this
      if (e.type != 'error') {
        let productIds = []

        productIds = e.params.map(item => {
          return item.productId
        })

        let params = {
          groupId: self.groupId,
          productList: productIds
        }
        PorductApi.addGroupProduct(params).then(res => {
          self.$message({
            message: '添加成功',
            type: 'success'
          })
          self.getData()
        }).catch(err => {
          self.$message({
            message: err.msg || '添加失败',
            type: 'error'
          })
        })
      }
      this.open_product = false
    },
    delClick: function (row) {
      let self = this
      let msg = ''
      msg = '删除后产品将从该分组中删除，确认删除该产品吗?'
      self.$confirm(msg, '提示', {
        type: 'warning'
      }).then(() => {
        PorductApi.DeleteGroupProduct({
          groupProductId: row.id
        }).then(data => {
          self.$message({
            message: '删除成功',
            type: 'success'
          })
          self.getData()
        })
      })
    },
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/product/group/plist.vue